<template>
  <div
    class="px-2 rounded-t-lg w-full overflow-y-auto relative transition-all duration-750 px-2 cursor-pointer h-full"
    :style="`${backgroundStyle}`"
    :class="computedClasses"
  >
    <GlobalDropdown
      v-if="isNotLoginPage"
      :copilotFocused="props.isCopilot"
      @refresh="emit('refresh')"
    />
    <div class="flex flex-col h-full">
      <header class="flex-none relative max-h-[65vh] py-2 rounded-b-xl">
        <slot name="header" :isViewScrolled="isMainViewScrolled"></slot>
      </header>
      <SearchWrapper
        ref="searchComponent"
        v-if="loggedIn && displaySearch"
        class="max-h-5 mt-0 z-20 mx-4"
      />
      <main
        class="bg-white overflow-y-auto overflow-x-hidden rounded-lg flex-grow relative border-white border-2 transition-all duration-750"
        ref="mainRef"
      >
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import GlobalDropdown from './GlobalDropdown.vue';
import SearchWrapper from '../Search/SearchWrapper.vue';
import { useAdminStore } from '@getmayday/vue-modules';

const adminStore = useAdminStore();
const { loggedIn } = storeToRefs(adminStore);

const configStore = useConfigStore();
const { integrationPrimaryColor } = storeToRefs(configStore);

const route = useRoute();
const mainRef = ref<HTMLElement | null>();
const isMainViewScrolled = ref(false);

const searchWhitelist = ['index', 'knowledge-viewer', 'collection-viewer'];

const searchComponent = ref<typeof SearchWrapper>();

const props = defineProps({
  backgroundColor: {
    type: String,
    default: null,
  },
  isCopilot: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits<{
  (e: 'refresh'): void;
}>();

const displaySearch = computed(() => {
  if (!route.name || typeof route.name === 'symbol') return false;
  return searchWhitelist.includes(route.name);
});

const backgroundStyle = computed(() => {
  if (props.isCopilot) return {};
  return `
  background: linear-gradient(to bottom, ${
    props.backgroundColor || integrationPrimaryColor.value
  } 0%, #ffffff calc(100% + 64px));
  `;
});

const computedClasses = computed(() => {
  const classes = [loggedIn.value ? 'pb-0' : 'pb-2'];
  if (props.isCopilot) {
    classes.push('mayday-ai-double-gradient');
  }
  return classes;
});

const isNotLoginPage = computed(() => route.name !== 'login');

onMounted(() => {
  if (!mainRef.value) return;
  mainRef?.value?.addEventListener('scroll', () => {
    const scrollPosition = mainRef.value?.scrollTop;
    if (!scrollPosition) return;
    isMainViewScrolled.value = scrollPosition > 20;
  });
});
</script>
<style scoped>
.mayday-ai-double-gradient {
  --ai-color-1: #83c3e5;
  --ai-color-2: #e093f4;
  --ai-color-3: #eb4d72;
  --ai-color-4: #f2b44d;
  background: linear-gradient(
      to bottom,
      rgba(242, 245, 249, 0.9) 0%,
      rgba(242, 245, 249, 1) 100%
    ),
    linear-gradient(
      to right,
      var(--ai-color-1),
      var(--ai-color-2),
      var(--ai-color-3),
      var(--ai-color-4)
    );
}
</style>
